import { Component, Input, OnInit } from "@angular/core";
import {ActionButton, DynamicCrudService, OggettoConfig} from "../_services/dynamic-crud.service";
import { ActivatedRoute, Router } from "@angular/router";
import { environment } from "src/environments/environment";
import { CampoAggiuntivo, CampoUtility } from "../models/campo-aggiuntivo";
import { Permission } from "src/app/Login/_guards/Permission";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { DynamicEditComponent } from "../dynamic-edit/dynamic-edit.component";
import { Title } from "@angular/platform-browser";
import { TranslateService } from "@ngx-translate/core";
import { GlobalStoreService } from "../_services/global-store.service";
import {ApiPathsService} from "../../api-paths.service";
import {ToastrService} from "ngx-toastr";
import {AuthenticationService} from "../../Login/_services/authentication.service";
import {debounceTime} from "rxjs/operators";
import {Subject, Subscription} from "rxjs";
import {UtilityService} from "../../utility.service";

@Component({
  selector: 'app-dynamic-list',
  templateUrl: './dynamic-list.component.html',
})
export class DynamicListComponent implements OnInit {
  CrudSettings: OggettoConfig = undefined;
  @Input() CrudId: string;
  environment = environment;
  @Input() openFilter: boolean = false;
  List: any[] = [];
  OriginalList: any[] = [];
  private ordine: { field: string, order: 'asc' | 'desc' } = { field: '', order: 'asc' };
  @Input() title: string = 'List';
  @Input() FilterViewType: 'normal' | 'sidebar' = 'normal';
  @Input() filtro: any = {}
  @Input() RowClickEnabled: boolean = true;
  @Input() ConcatParams: any = {};
  @Input() ConcatParamsEdit: any = {};
  totalItems:number =0;
  ListResponse: any;
  subscriptions: Subscription[] = [new Subscription()];
  currentSearchCount = 0;
  dynamicStyle;
  addDynamicStyle() {
    if (!this.CrudSettings?.ListStyle && this.dynamicStyle) {
      document.head.removeChild(this.dynamicStyle);
      this.dynamicStyle = null; // pul
      return;
    }else if(!this.CrudSettings?.ListStyle)
      return;

    this.dynamicStyle = document.createElement('style');
    this.dynamicStyle.innerHTML = `${this.CrudSettings.ListStyle}`;
    document.head.appendChild(this.dynamicStyle);

  }
  constructor(
    private crudService: DynamicCrudService,
    private activeRoute: ActivatedRoute,
    public campoUtility: CampoUtility,
    public permission: Permission,
    private modalService: NgbModal,
    private titleService: Title,
    public translate: TranslateService,
    private router: Router,
    private globalStore: GlobalStoreService,
    private api:ApiPathsService,
    private toastService: ToastrService,
    public authSvc: AuthenticationService
  ) { }
  private searchDebouncer$: Subject<any> = new Subject();
  private setupSearchDebouncer(): void {
    this.searchDebouncer$.pipe(
      debounceTime(1000),
    ).subscribe((term: any) => {
      this.performRefresh();
    });
  }

  ngOnInit() {
    this.setupSearchDebouncer();
    if (!this.CrudId)
      this.activeRoute.params.subscribe(
        (params: { type: string }) => {
          this.CrudSettings = this.crudService.GetCrudSettings(params.type);
          this.filtro = {};
          this.addDynamicStyle();
          this.performRefresh();
        }
      );
    else {
      this.CrudSettings = this.crudService.GetCrudSettings(this.CrudId);
      this.addDynamicStyle();
      this.performRefresh();
    }
  }
  Refresh() {
    this.searchDebouncer$.next();
  }

  performRefresh(){
    const filter = { page: 1, size: 50, ...(this.CrudSettings.ListDefaultFilter? DeepCopy(this.CrudSettings.ListDefaultFilter): {}), ...(this.CrudSettings.ListDefaultFilterFunc? this.CrudSettings.ListDefaultFilterFunc(this): {}) };
    this.filtro = Object.assign({}, filter, this.filtro);
    if (!this.CrudId)
      this.updateTitle();
    this.subscriptions[this.currentSearchCount].unsubscribe();

    this.subscriptions.push(new Subscription());
    this.currentSearchCount++;
    this.subscriptions[this.currentSearchCount].add(


    this.crudService.GetList(Object.assign({}, this.CrudSettings), this.filtro).subscribe(response => {
      this.List = this.CrudSettings.ListResponseHasData ? (this.CrudSettings.ListMap ? this.CrudSettings.ListMap(response.data) : response.data) : (this.CrudSettings.ListMap ? this.CrudSettings.ListMap(response) : response);
      this.OriginalList = Object.assign([], this.List);
      this.ListResponse = response;
      this.totalItems =response.total;
      if(this.CrudSettings.DynamicHeaders)
        this.CrudSettings.Headers = this.CrudSettings.DynamicHeaders(this)
    },error => {
      console.error("errore: ", error,"Settings: ", this.CrudSettings);
    }));
  }

  hasExportButtons(){
    return  (this.CrudSettings.PrintHeaders?.filter(header => header.printable != false) ?? this.CrudSettings.Headers?.filter(header => header.printable != false))?.length;

  }
  hasListActions() {
    return this.CrudSettings && this.CrudSettings['AzioniLista']?.filter(x => !x.single)?.length > 0;
  }
  MassiveButtonClick(button) {
    this.crudService.MultipleCustomButtonClick(this.List.filter(x => x['selected']), button, true, this.CrudSettings, (end) => this.Refresh(), (refresh) => { this.Refresh() }, (close) => { })
  }
  ButtonClick(item, button) {
    this.crudService.CustomButtonClick(item, button, true, this.CrudSettings, (end) => this.Refresh(), (refresh) => { this.Refresh() }, (close) => { })
  }
  customButton( button: ActionButton) {
    if (button.func)
      button.func(this.List, this.api, () => { this.Refresh()}, this.toastService)
    else
      this.crudService.CustomButtonClick(this.List, button, true, this.CrudSettings, (end) => this.Refresh(), (refresh) => { this.Refresh() }, (close) => { })
  }
  dynamicHeader() {
    return this.CrudSettings?.Headers;
  }
  IsArray(val) {
    return val && Array.isArray(val);
  }
  headShow(campo): boolean {
    return true;
  }
  allSelected(headerField: any, data: any[]) {
    return data?.every(x => x[headerField]);
  }

  toggleAll(headerField: any, data: any[]) {
    var oldValue = Object.assign({}, { val: this.allSelected(headerField, data) })
    data?.forEach((x) => x[headerField] = !oldValue.val)
  }
  RowClick(Item) {
    if ((this.CrudSettings && this.CrudSettings['DisableEdit']) || (!this.RowClickEnabled || this.dynamicHeader()?.some(x => x.modificabile)) || !this.CrudSettings.campi) return;
    this.OpenEdit(Item);
  }
  EditButton(Item) {
    if(this.CrudSettings && !this.CrudSettings['DisableEdit'])
    this.OpenEdit(Item);
  }
  HasAddButton() {
    return this.CrudSettings?.HasAddList &&
      this.campoUtility.CheckValue(this.CrudSettings?.HasAddList, Object.assign({}, this.CrudSettings.ListDefaultFilter, this.filtro)) &&
      this.permission.HasCapacity(this.CrudSettings.Capacita);
  }
  AddClick() {
    this.OpenEdit()
  }
  OpenEdit(Item?: Object) {
    if (!this.CrudSettings.EditView)
      this.OpenEditModal(Item)
    else
      switch (this.CrudSettings.EditView) {
        case 'Modal':
          this.OpenEditModal(Item);
          break;
        case 'Page':
          this.OpenEditPage(Item);
          break;
      }
  }
  OpenEditModal(Item?: Object) {
    const EditModal = this.modalService.open(DynamicEditComponent, {
      centered: true,
      backdrop: 'static',
      container: '#main-wrapper',
      size: 'xl'
    });
    var obj = Item ? Object.assign({}, Item ?? {}, this.ConcatParamsEdit) : Object.assign(this.CrudSettings.AddDefaultObject ?? {}, this.ConcatParams);
    (<DynamicEditComponent>EditModal.componentInstance).CrudSettings = this.CrudSettings;
    (<DynamicEditComponent>EditModal.componentInstance).ConcatParamsEdit = this.ConcatParamsEdit;
    (<DynamicEditComponent>EditModal.componentInstance).Item = obj;
    (<DynamicEditComponent>EditModal.componentInstance).updated.subscribe(data => {
      setTimeout(() => { this.Refresh(); }, 1000)
    });
  }
  OpenEditPage(Item?: any) {
    var params = [this.CrudSettings.Id, Item?.id];
    var link = `shared/dynamicedit/${params?.filter(x => x).join('/')}`;
    if (!Item?.id)
      this.globalStore.setData(Item);
    this.router.navigate([this.activeRoute.snapshot.queryParams[link] || link,]);
  }
  ExportCsv() {
    this.Export("csv");
  }
  ExportXlsx() {
    this.Export("xlsx");
  }

  Export(type: "csv" | "xlsx", completo?:boolean){
    if(this.CrudSettings?.FullExportExcel && this.totalItems > this.filtro.size && completo){
      (async () => {
        const allItems = await this.getAll(this.filtro.size, this.totalItems);
        this.Download(allItems, type);
      })();
    }
    else if(this.List.some(x => x['selected'])){
      this.Download(this.List.filter(x => x['selected']), type);
    } else
     this.Download(this.List, type);
  }
  Download(items: any[], type: "csv" | "xlsx"){
    switch (type) {
      case "csv":
        this.crudService.DownloadCsv(items, this.CrudSettings, `${this.CrudSettings.listTitle} Export`, {});
        break;
      case "xlsx":
        this.crudService.Downloadxlsx(items, this.CrudSettings, `${this.CrudSettings.listTitle} Export`, {});
        break;
    }
  }
  async  fetch(page: number, size: number): Promise<any[]> {
    console.log(`Chiamata pagina ${page+1}`);
    const response = await  this.crudService.GetList(Object.assign({}, this.CrudSettings), {...this.filtro, page: page+1}).toPromise();

    return response.data;
  }
  async  getAll(
    size: number,
    totalItems: number,
    page: number = 0,
    acc: any[] = []
  ): Promise<any[]> {

    const totalPages = Math.ceil(totalItems / size);

    // condizione di uscita
    if (page >= totalPages) {
      return acc;
    }

    // chiamata API
    const data = await this.fetch(page, size);

    // ricorsione
    return this.getAll(
      size,
      totalItems,
      page + 1,
      [...acc, ...data]
    );
  }

  order(campo: CampoAggiuntivo) {
    var order: 'asc' | 'desc' = campo.nome == this.ordine.field ? (this.ordine.order == 'asc' ? 'desc' : 'asc') : 'asc'
    this.List = this.campoUtility.getSortedList(this.OriginalList, campo, order);
    this.ordine = { field: campo.nome, order: order }
  }

  private updateTitle() {
    var MenuPath = this.findMenuPath(this.CrudSettings.MenuItems, this.router?.url);
    this.title = this.CrudSettings.listTitle
    this.titleService.setTitle(this.translate.instant(MenuPath?.reverse()?.find(x=>true) ?? this.title ?? 'Lista'));
  }
  Tooltip(item) {
    return ''
  }

  Stampe(item) {
    return item?.stampe?.filter(stampa => (!item?.template && item.tipo != "F") || stampa.id == item.template);
  }
  onPageChange(page){
    if(!this.CrudSettings?.ListDefaultFilter || this.CrudSettings?.ListDefaultFilter['page'] != 0) {
      this.filtro.page = page;
      this.Refresh();
    }
  }
  findMenuPath(menu, targetPath) {
    if (Array.isArray(menu))
    for (const item of menu) {
      if (item.path?.replace(/\//gi, '') == targetPath?.replace(/\//gi, '')) {
        return [item.title];
      }

      if (item.submenu) {
        const subPath = this.findMenuPath(item.submenu, targetPath);
        if (subPath) {
          return [item.title, ...subPath];
        }
      }
    }

    return null;
  }
}

function DeepCopy(item: any): any {
  return JSON.parse(JSON.stringify(item));
}
